import {
  GetProvinces,
  GetCitys,
  GetAreas
} from '@api/commonApi.js';
import {
  util
} from 'utils';
import {
  lg
} from 'utils';

export default {
  methods: {
    //根据省份获取城市列表
    getCity(provincesId) {
      let Params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        ProvinceId: provincesId
      };
      GetCitys(Params).then(res => {
        util.doResult(this, res, () => {
          this.cityList = res.data.Data;
          if (this.value !== null) {
            if (this.value.ProvId !== provincesId) {
              this.companyInfo.CityId = this.cityList[0].Id
            }
          } else if (this.companyInfo.ParentCustomerId == 0) {
            this.companyInfo.CityId = this.cityList[0].Id
          }
        });
      });
    },
    //根据城市获取区/县列表
    getArea(CityId) {
      let Params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        CityId: CityId
      };
      GetAreas(Params).then(res => {
        util.doResult(this, res, () => {
          this.areaList = res.data.Data;
          if (this.value !== null) {
            if (this.value.CityId !== CityId) {
              this.companyInfo.AreaId = null
            }
          } else if (this.companyInfo.ParentCustomerId == 0) {
            this.companyInfo.AreaId = null
          }

        });
      });
    }
  }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/agent-base-infonew/services.js